import { PermissionsEnum } from '@shared/features/user/user-roles.interface';

export enum TabTypesEnum {
  REESTR_MODULE = 'REESTR_MODULE',
  CALLBACK_MODULE = 'CALLBACK_MODULE',
}

export enum APPLICATION_STATUSES {
  CREATED = 'CREATED',
  REJECTED = 'REJECTED',
  ACCEPTED = 'ACCEPTED',
  SALES = 'SALES',
  AWAITING_PAYMENT = 'AWAITING_PAYMENT',
  READY_TO_PROCESS = 'READY_TO_PROCESS',
  BRIGADE = 'BRIGADE',
  BRIGADE_ON_WAY = 'BRIGADE_ON_WAY',
  STARTED = 'STARTED',
  PARTIAL_FINISHED = 'PARTIAL_FINISHED',
  FINISHED = 'FINISHED',
}

/**
 * Maps a role code to the list of status ids that role is allowed to see.
 * An empty array means the role can see ALL statuses.
 * Roles not listed here default to seeing all statuses.
 */
export const roleStatusMap: Partial<Record<PermissionsEnum, APPLICATION_STATUSES[]>> = {
  [PermissionsEnum.SALES]: [APPLICATION_STATUSES.SALES],
  [PermissionsEnum.ACCOUNTANT]: [APPLICATION_STATUSES.ACCEPTED],
  [PermissionsEnum.OPERATOR]: [], // all statuses
};

export const specialTechniquesStatusesMap = {
  [APPLICATION_STATUSES.CREATED]: APPLICATION_STATUSES.CREATED,
  [APPLICATION_STATUSES.REJECTED]: APPLICATION_STATUSES.REJECTED,
  [APPLICATION_STATUSES.ACCEPTED]: APPLICATION_STATUSES.ACCEPTED,
  [APPLICATION_STATUSES.BRIGADE]: APPLICATION_STATUSES.BRIGADE,
  [APPLICATION_STATUSES.FINISHED]: APPLICATION_STATUSES.FINISHED,
};

export const commonBadge = {
  count: 0,
  textColor: 'white',
  bgColor: '#f59e0b',
};

export const statusTabs: {
  id: string;
  name: string;
  active?: boolean;
  badge?: {
    count: string | number;
    textColor: string;
    bgColor: string;
  };
}[] = [
  {
    id: '',
    name: 'all.applications',
    active: true,
    badge: {
      count: 0,
      textColor: 'white',
      bgColor: '#f59e0b',
    },
  },
  {
    id: APPLICATION_STATUSES.CREATED,
    name: APPLICATION_STATUSES.CREATED,
  },
  {
    id: APPLICATION_STATUSES.SALES,
    name: APPLICATION_STATUSES.SALES,
  },
  {
    id: APPLICATION_STATUSES.REJECTED,
    name: APPLICATION_STATUSES.REJECTED,
  },
  {
    id: APPLICATION_STATUSES.ACCEPTED,
    name: APPLICATION_STATUSES.ACCEPTED,
  },
  {
    id: APPLICATION_STATUSES.AWAITING_PAYMENT,
    name: APPLICATION_STATUSES.AWAITING_PAYMENT,
  },
  {
    id: APPLICATION_STATUSES.READY_TO_PROCESS,
    name: APPLICATION_STATUSES.READY_TO_PROCESS,
  },
  {
    id: APPLICATION_STATUSES.BRIGADE,
    name: APPLICATION_STATUSES.BRIGADE,
  },
  {
    id: APPLICATION_STATUSES.BRIGADE_ON_WAY,
    name: APPLICATION_STATUSES.BRIGADE_ON_WAY,
  },
  {
    id: APPLICATION_STATUSES.STARTED,
    name: APPLICATION_STATUSES.STARTED,
  },
  {
    id: APPLICATION_STATUSES.PARTIAL_FINISHED,
    name: APPLICATION_STATUSES.PARTIAL_FINISHED,
  },
  {
    id: APPLICATION_STATUSES.FINISHED,
    name: APPLICATION_STATUSES.FINISHED,
  },
];

export const applicationStatusesClasses = [
  {
    id: APPLICATION_STATUSES.CREATED,
    classes: 'text-md font-medium bg-gray-50 text-gray-600 border border-gray-200 rounded-full px-2 py-0.5',
  },
  {
    id: APPLICATION_STATUSES.REJECTED,
    classes: 'text-md font-medium bg-red-50 text-red-600 border border-red-200 rounded-full px-2 py-0.5',
  },
  {
    id: APPLICATION_STATUSES.ACCEPTED,
    classes: 'text-md font-medium bg-blue-50 text-blue-600 border border-blue-200 rounded-full px-2 py-0.5',
  },
  {
    id: APPLICATION_STATUSES.SALES,
    classes: 'text-md font-medium bg-purple-50 text-purple-600 border border-purple-200 rounded-full px-2 py-0.5',
  },
  {
    id: APPLICATION_STATUSES.AWAITING_PAYMENT,
    classes: 'text-md font-medium bg-yellow-50 text-yellow-700 border border-yellow-200 rounded-full px-2 py-0.5',
  },
  {
    id: APPLICATION_STATUSES.READY_TO_PROCESS,
    classes: 'text-md font-medium bg-lime-50 text-lime-700 border border-lime-200 rounded-full px-2 py-0.5',
  },
  {
    id: APPLICATION_STATUSES.BRIGADE,
    classes: 'text-md font-medium bg-orange-50 text-orange-600 border border-orange-200 rounded-full px-2 py-0.5',
  },
  {
    id: APPLICATION_STATUSES.BRIGADE_ON_WAY,
    classes: 'text-md font-medium bg-amber-50 text-amber-600 border border-amber-200 rounded-full px-2 py-0.5',
  },
  {
    id: APPLICATION_STATUSES.STARTED,
    classes: 'text-md font-medium bg-cyan-50 text-cyan-600 border border-cyan-200 rounded-full px-2 py-0.5',
  },
  {
    id: APPLICATION_STATUSES.PARTIAL_FINISHED,
    classes: 'text-md font-medium bg-teal-50 text-teal-600 border border-teal-200 rounded-full px-2 py-0.5',
  },
  {
    id: APPLICATION_STATUSES.FINISHED,
    classes: 'text-md font-medium bg-green-50 text-green-600 border border-green-200 rounded-full px-2 py-0.5',
  },

  // request statuses
  {
    id: 'SUPPLIED',
    classes: 'text-md bg-green-100 text-green-700 border rounded-md px-1',
  },
];
